export default __webpack_public_path__ + "static/media/lb.a5038a58.svg";